import React from 'react';
import PropTypes from 'prop-types';

class Label extends React.Component {
  render() {
    return (
      <span className={`label ${this.props.theme}`}>
        {this.props.icon ? <i className={`fa ${this.props.icon}`} /> : ''}
        {this.props.icon && this.props.stat ? ' ' : ''}
        {this.props.stat}
      </span>
    );
  }
}

Label.propTypes = {
  theme: PropTypes.string,
  icon: PropTypes.string,
  stat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

Label.defaultProps = {
  theme: 'label-primary',
  icon: '',
  stat: ''
};

export default Label;
